import { Button } from "react-bootstrap";
import styled from "styled-components";

const StyledPrimayButton = styled(Button)`
    width: 112px;
    height: 48px;
    background: #8a0538;
    border: 1px solid #8a0538;
    border-radius: 24px;
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    &:disabled {
        width: 112px;
        height: 48px;
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
        border-radius: 24px;
        color: #404040;
        font-size: 16px;
        line-height: 100%;
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
    }
`;

const StyledDefaultButton = styled(Button)`
    width: 100px;
    height: 48px;
    background: #fff;
    border: 1px solid #8a0538;
    border-radius: 24px;
    color: #8a0538;
    margin: 0px 12px 0px;
    font-size: 16px;
    line-height: 100%;
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    > svg {
        fill: #8a0538;
    }
    &:disabled {
        width: 130px;
        height: 48px;
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
        border-radius: 24px;
        color: #404040;
        font-size: 16px;
        line-height: 100%;
        > svg {
            fill: #787878;
        }
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
        > svg {
            fill: #ffff !important;
        }
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
        > svg {
            fill: #ffff;
        }
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
        > svg {
            fill: #ffff;
        }
    }
`;

const StyledDefaultButtonLink = styled(Button)`
    color: #8a0538;
    margin: 0px 12px 0px;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    > a {
        color: inherit;
        text-decoration: inherit;
    }

    &:disabled {
        color: #787878 !important;
        font-size: 16px;
        line-height: 100%;
        > svg {
            fill: #787878 !important;
        }
    }
    &:hover {
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
`;

const StyledTarjaAmbiente = styled(Button)`
    display: ${(props) => (props.$show ? "none" : "flex")};
    align-items: center;
    justify-content: center;
    padding: 0px;

    border-radius: 30px;
    color: #fff;
    background-color: #ff0040;
    width: 281px;
    height: 32px;
    left: 469px;
    top: 24px;

    cursor: default !important;

    /* alta especificidade para sobrescrever as regras de :hover/:focus/:active do Bootstrap */
    && {
        background-color: #ff0040 !important;
        border-color: transparent !important;
        box-shadow: none !important;
        color: inherit !important;
    }
    &&:hover,
    &&:focus,
    &&:active {
        background-color: #ff0040 !important;
        border-color: transparent !important;
        box-shadow: none !important;
        color: inherit !important;
    }
    &&:focus {
        outline: none !important;
    }
`;

export {
    StyledDefaultButtonLink,
    StyledPrimayButton,
    StyledDefaultButton,
    StyledTarjaAmbiente,
};
